import { render, staticRenderFns } from "./AreaStatistics.vue?vue&type=template&id=888fae5a&scoped=true"
import script from "./AreaStatistics.vue?vue&type=script&lang=js"
export * from "./AreaStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888fae5a",
  null
  
)

export default component.exports